import xhrModule from '../xhrModule.js'

var formResourcesManager = {
	entities: {},
	resources: {
		status: 'idle',
		data: {},
		callbacks: []
	},
	forms: {},
	markets: {},
	fetchStarted: false,
	fetchCompleted: false,
	callsToFinish: 0,
	regularEndpoints: {},

	incrementCallToFinish: function () {
		this.callsToFinish++
		this.callsAllDone()
	},

	subtractCallToFinish: function () {
		this.callsToFinish--
		this.callsAllDone()
	},

	callsAllDone: function () {
		// end of calls
	},

	fetchOtherEndpoints: function (callback, url) {
		// if the endpoints has not been fetched yet
		if (!this.regularEndpoints[url]) {
			this.regularEndpoints[url] = {
				status: 'idle',
				data: {},
				callbacks: []
			}
		}

		// when the call has finished we can just return the results
		if (this.regularEndpoints[url].data.data) {
			callback(this.regularEndpoints[url].data)
			return
		}

		// add callback to callbacks array
		this.regularEndpoints[url].callbacks.push(callback)

		// set endpoint as started
		if (this.regularEndpoints[url].status === 'started') return
		this.regularEndpoints[url].status = 'started'

		// make the call
		this.incrementCallToFinish()
		xhrModule.get(url, this.otherEndpointsFetched.bind(this))
	},

	otherEndpointsFetched: function (data) {
		this.regularEndpoints[data.url].status = 'completed'
		this.regularEndpoints[data.url].data = data

		this.subtractCallToFinish()
		var callbacks = this.regularEndpoints[data.url].callbacks
		for (var i = callbacks.length - 1; i >= 0; i--) {
			callbacks[i](this.regularEndpoints[data.url].data)

			// remove callback after it has been used
			callbacks.splice(i, 1)
		}
	},

	fetchForm: function (callback, id) {
		// if the form id does not exist yet
		if (!this.forms[id]) {
			this.forms[id] = {
				status: 'idle',
				data: {},
				callbacks: []
			}
		}

		// when the call has finished we can just return the results
		if (Object.keys(this.forms[id].data).length > 0) {
			callback(this.forms[id].data)
			return
		}

		this.forms[id].callbacks.push(callback)
		if (this.forms[id].status === 'started') return
		this.forms[id].status = 'started'

		// make the call
		this.incrementCallToFinish()
		var url = '/cms/api/forms?entity=' + id
		xhrModule.get(url, this.formFetched.bind(this))
	},

	formFetched: function (data) {
		var form = data.data[Object.keys(data.data)[0]]
		var entityID = form.entity.id
		this.forms[entityID].status = 'completed'
		this.forms[entityID].data = data.data

		this.subtractCallToFinish()
		var callbacks = this.forms[entityID].callbacks
		for (var i = callbacks.length - 1; i >= 0; i--) {
			callbacks[i](this.forms[entityID].data)
		}
	},

	fetchResources: function (callback) {
		if (this.fetchCompleted) callback(this.resources.data)
		this.resources.callbacks.push(callback)
		if (this.fetchStarted) return
		this.fetchStarted = true

		this.incrementCallToFinish()
		var url = '/cms/api/resources'
		xhrModule.get(url, this.internalLinksFetched.bind(this))
	},

	internalLinksFetched: function (data) {
		this.fetchCompleted = true
		this.subtractCallToFinish()
		var callbacks = this.resources.callbacks
		for (var i = callbacks.length - 1; i >= 0; i--) {
			callbacks[i](data)
		}
	},

	reset: function () {
		this.entities = {}
		this.resources = {
			status: 'idle',
			data: {},
			callbacks: []
		}
		this.forms = {
			data: {},
			callbacks: []
		}

		this.regularEndpoints = {}

		this.fetchStarted = false
		this.callsToFinish = 0
	}
}

export default formResourcesManager
